import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import CopyToClipboardButton from '../../components/molecules/CopyToClipboardButton';
import Tooltip from '../../components/molecules/Tooltip';
import { setAdminMode } from '../../actions/user';
import { getAdminModeEnabled, getUserData } from '../../selectors/user';
import { ANGULAR_ADMIN_MODE_CHANGED_EVENT } from '../../components/pages/reports/consts';
import { HEADERS, SHOW_IMPERSONATION_MODAL_EVENT } from '../consts';
import { stripImpersonationParam } from '../utils';
import css from '../style.css';

function AdminActions() {
    const dispatch = useDispatch();
    const userData = useSelector(getUserData) || {};
    const adminMode = useSelector(getAdminModeEnabled);

    const isAdmin = !!userData.is_admin;
    const showImpersonation = !!userData.is_impersonator;

    if (!isAdmin && !showImpersonation) {
        return null;
    }

    const onToggleAdminMode = () => {
        const enabled = !adminMode;
        dispatch(setAdminMode(enabled));
        window.dispatchEvent(new CustomEvent(ANGULAR_ADMIN_MODE_CHANGED_EVENT, { detail: { enabled } }));
    };

    const impersonationButton = (
        <button
            type="button"
            aria-label="impersonate user"
            className={css.iconButton}
            onClick={() => window.dispatchEvent(new CustomEvent(SHOW_IMPERSONATION_MODAL_EVENT))}
        >
            <Icon name="spy" size={IconSizes.SMALL} variant={IconVariants.WHITE} interactive={false} />
        </button>
    );

    return (
        <>
            {adminMode && isAdmin && (
                <span className={css.planChip}>
                    {userData.company} - {userData.organization_id}
                </span>
            )}
            {isAdmin && (
                <CopyToClipboardButton
                    textToCopy={stripImpersonationParam(window.location.href)}
                    preCoyIconName="link"
                    tooltip={`${HEADERS}.COPY_CURRENT_URL`}
                    buttonClassName={css.iconButton}
                    copiedButtonClassName={css.iconButtonCopied}
                    ariaLabel="copy current url"
                    iconSize={IconSizes.SMALL}
                    copiedIconSize={IconSizes.MEDIUM}
                    iconVariant={IconVariants.WHITE}
                    copiedIconVariant={IconVariants.WHITE}
                />
            )}
            {showImpersonation && (
                <Tooltip
                    titleTranslationKey={`${HEADERS}.IMPERSONATE_USER_SHORTCUT`}
                    position="bottom"
                    style={{ display: 'flex', height: '100%' }}
                >
                    {impersonationButton}
                </Tooltip>
            )}
            {isAdmin && (
                <button
                    type="button"
                    aria-label="toggle admin mode"
                    className={classNames(css.iconButton, { [css.iconButtonActive]: adminMode })}
                    onClick={onToggleAdminMode}
                >
                    <Icon name="crown" size={IconSizes.SMALL} variant={IconVariants.WHITE} />
                </button>
            )}
        </>
    );
}

export default AdminActions;
